import React from 'react'
import { Box, CircularProgress, keyframes } from '@mui/material'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import { useTheme } from '@mui/material/styles'

// アニメーション用の定数
const ANIMATION_CONSTANTS = {
  container: {
    width: 80,
    height: 60,
  },
} as const

// 控えめなパルス効果
const gentlePulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
`

export const AIPreparingAnimation: React.FC = () => {
  const theme = useTheme()

  return (
    <Box
      role="status"
      aria-label="服薬指導を準備中"
      sx={{
        position: 'relative',
        width: ANIMATION_CONSTANTS.container.width,
        height: ANIMATION_CONSTANTS.container.height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* 外周のプログレスリング */}
      <CircularProgress
        size={50}
        thickness={2}
        sx={{
          position: 'absolute',
          color: theme.palette.grey[400],
          opacity: 0.5,
        }}
      />

      {/* 中央のAIアイコン */}
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          backgroundColor: 'rgba(158, 158, 158, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: `${gentlePulse} 2.5s ease-in-out infinite`,
        }}
      >
        <SmartToyIcon
          sx={{
            fontSize: 20,
            color: theme.palette.grey[600],
          }}
        />
      </Box>
    </Box>
  )
}
